<!-- 数据更新时间 -->
<template>
    <div class="user-update">
        <span class="user-update-text">数据更新时间：</span>
        <span class="user-update-time">{{ currentTime }}</span>
        <img :class="['reset-img', updateTimeBigdataList.resetClassName, resetLoading ? 'rotate' : '']"
            src="@/assets/images/icon-reset.png" alt="" @click="resetCurrent()">
        <img :class="['close-img', updateTimeBigdataList.closeClassName,]" src="@/assets/images/icon-close.png" alt=""
            @click="close()">
    </div>
</template>
<script>
import { ref, getCurrentInstance } from '@vue/composition-api';
import { parseTime } from '@/utils/index.js';
import PubSub from 'pubsub-js';
import { mapGetters } from 'vuex';
import _ from 'lodash';
export default {
    props: {
        updateTimeBigdataList: {
            type: Object,
            return: () => {
                return {};
            }
        }
    },
    computed: {
        ...mapGetters(['visitedViews'])
    },
    setup(props, setupContext) {
        // 获取当前页面路由并传参过去
        const ctx = getCurrentInstance();
        const currentTime = ref(parseTime(new Date(), 'yyyy-MM-dd'));
        const resetLoading = ref(false);
        // 把resetCurrent emit出去
        const resetCurrent = () => {
            setupContext.emit('reset-current');
            currentTime.value = parseTime(new Date(), 'yyyy-MM-dd');
        };
        const close = () => {
            const _name = ctx.$route.name;
            PubSub.publish('close-update-time', _name);
            ctx.$router.push({
                path: '/index'
            });
        };
        return {
            currentTime,
            resetLoading,
            resetCurrent,
            close
        };
    }
};
</script>
<style lang="less" scoped>
.user-update {
    display: flex;
    align-items: center;
    margin-left: 12px;

    .user-update-text {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #86909C;
        line-height: 12px;
        display: flex;
        align-items: center;
    }

    .time-icon-pic {
        width: 14px;
        height: 14px;
    }

    .user-update-time {
        height: 12px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 12px;
    }

    .reset-img,
    .close-img {
        width: 16px;
        height: 16px;
        margin: 0px 0px 0px 20px;
        cursor: pointer;
    }
}

/* 旋转动画 */
.rotate {
    animation: spin 0.8s infinite;
}

/* 定义旋转动画关键帧 */
@keyframes spin {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>
